import Vue from "vue";

export class Pontos {
    static create() {
        return {
            ssh: {
                host: null,
                username: null,
                password: null,
                readyTimeout: 5000,
                algorithms: {
                    serverHostKey: ["ssh-rsa", "ssh-dss"]
                }
            },
            radius: 2000,
            icon: "compass.png",
            geocode: {
                latitude: 0,
                longitude: 0
            },
            access_points: [],
            nome: null
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("ponto/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("ponto/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static sendComandoAll(data) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("pontos/comandos-all", data)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("pontos")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static allPontos() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("pontos/position")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("pontos", data);
            } else {
                promisse = Vue.http.post("pontos", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
